import { render, staticRenderFns } from "./RoomSetting.vue?vue&type=template&id=fe83ed46&scoped=true"
import script from "./RoomSetting.vue?vue&type=script&lang=js"
export * from "./RoomSetting.vue?vue&type=script&lang=js"
import style0 from "./RoomSetting.vue?vue&type=style&index=0&id=fe83ed46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe83ed46",
  null
  
)

export default component.exports